/* eslint-disable import/no-default-export */
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {Experiments} from '../../constants';
import {ConditionalController} from '@wix/wixstores-client-storefront-common';
import {SliderGalleryController} from '../../viewerScript/SliderGalleryController';
import {OldSliderGalleryController} from '../../viewerScript/OldSliderGalleryController';

export default ConditionalController(
  Experiments.RemoveControllerFactory,
  SliderGalleryController,
  controllerFactory(OldSliderGalleryController, {shouldSkipMultilingual: true})
);
